// Temple-configurable CTA destinations.
//
// Each option links somewhere different, and links differ per temple. To add a
// temple, add an entry to `temples` and point `activeTemple` at it (an admin
// panel or a geolocation lookup can set this later — see suggestion below).
//
// FUTURE (planned, not built yet):
//  - Admin config: store `temples` in the DB and pick `activeTemple` from an
//    admin setting or a ?temple=iskcon_juhu query param on the campaign QR link.
//  - Geolocation: map the visitor's city/coords to the nearest temple key.

export const temples = {
  iskcon_juhu: {
    name: "ISKCON Juhu",
    bhagavatam: "#",
    mahaprasadam: "#",
    chanting: "https://www.youtube.com/@ISKCONJuhuTemple",
    darshan: "#",
    beginJourney: "#",
  },
  // default fallback temple
  default: {
    name: "ISKCON",
    bhagavatam: "#",
    mahaprasadam: "#",
    chanting: "https://www.youtube.com/@ISKCONJuhuTemple",
    darshan: "#",
    beginJourney: "#",
  },
};

export const activeTemple = "iskcon_juhu";

export const links = temples[activeTemple] || temples.default;
